module.exports = __webpack_public_path__ + "static/media/11a.b933f93d.jpg";